export default __webpack_public_path__ + "static/media/File No. 25.26f9c753.pdf";